import { t as __t } from "i18next";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import moment from "moment";

import { notifyListRefresh } from "../../../utils/listNavigation";
import { callUploadFile } from "../../../api/settings/service";
import {
  callGetContractByKey,
  callgetVehicleCaseIdiomsByContract,
  callgetVehicleCaseIdiomsById,
  reqClameLifeContract,
} from "../../../api/contract/service";
import { bankList, decodeBase64 } from "../../../utils/commonUtil";

import DashboardHeader from "../../../components/header/DashboardHeader";
import DashboardEmployerSidebar from "../../../components/header/DashboardSidebar";
import MobileMenu from "../../../components/header/MobileMenu";
import CopyrightFooter from "../../../components/footer/employers/CopyrightFooter";
import FileUploadGrid from "../../../components/upload-file";
import InputNumberFormat from "../../../components/input";
import SwalAlert from "../../../components/common/alert";

import "../../../components/i18n/lang";
import "./clame.css";

const VehicleClaim = () => {
  const userInfo = useSelector((state) => state.dataLogin);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const { t } = useTranslation();

  const [contractDetail, setContractDetail] = useState(null);
  const [loadingContract, setLoadingContract] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const [request, setRequest] = useState({
    note: "",
    bankAccName: "",
    bankAcc: "",
    bankType: "",
    bankMethod: "",
    userId: userInfo?.data?.user?.userId,
    contractNumber: null,
    deadDate: "",
    claimCause: 2,
    methodReceiveMoney: 1,
    caseIdiomsCode: "",
    claimTypeId: 2,
    carriredCode: userInfo?.data?.user?.userId,
    carriredName:
      userInfo?.data?.user?.firstName +
      " " +
      (userInfo?.data?.user?.lastName || ""),
    requestOs: "web",
    claimAmount: 0,
    documentPath: "",
    documentFile: null,
    description: "",
    customerAmount: "",
    targetAmount: "",
    deathAmount: "",
    hotpitalAmount: "",
    editerAmount: "",
    amountType: "customerAmount",
    address: "",
    licensePlate: "",
    thirdPartyLicensePlate: "",
  });

  useEffect(() => {
    if (!params?.data) return;

    try {
      const data = JSON.parse(decodeBase64(params.data));
      const selectedContract = data.contractNo || data.contractNumber;

      hydrateCaseToClaim(data);
      loadClaimData(data);
      loadDataContract(selectedContract);
    } catch (error) {
      console.error("Decode vehicle claim data error:", error);
      SwalAlert.error(
        t("claimPages.common.errorTitle"),
        t("claimPages.vehicle.readError")
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.data]);

  const loadDataContract = async (value) => {
    if (!value) return;

    try {
      setLoadingContract(true);
      const rsp = await dispatch(
        callGetContractByKey({
          keyword: value,
          page: 1,
          maxResult: 1,
          insuranceType: 2,
        })
      );

      if (rsp?.payload?.responseCode === "00000") {
        const row = rsp?.payload?.data?.result?.[0] || null;
        setContractDetail(row);

        if (row?.statusPayment === 3) {
          SwalAlert.error("", t("claimPages.vehicle.unpaidContract"), () => navigate(-1), false);
        }
      }
    } catch (error) {
      console.error("Load vehicle contract error:", error);
    } finally {
      setLoadingContract(false);
    }
  };

  const hydrateCaseToClaim = (data = {}) => {
    const selectedContract = data.contractNo || data.contractNumber;

    setRequest((prev) => ({
      ...prev,
      ...data,
      deadDate: data.accidentDate
        ? new Date(String(data.accidentDate).replace("Z", ""))
        : prev.deadDate,
      contractNumber: selectedContract || prev.contractNumber,
      description: data.accidentNote || "",
      caseIdiomsCode: data.caseIdiomsCode || prev.caseIdiomsCode,
      thirdPartyLicensePlate:
        data.thirdPartyLicensePlate ||
        data.thirdPartyVehicles?.[0]?.licensePlate ||
        prev.thirdPartyLicensePlate,
      licensePlate:
        data.licensePlate || data.vehicleInfo?.licensePlate || prev.licensePlate,
      addressItem:
        data.address ||
        [data.provinceName, data.districtName, data.village]
          .filter(Boolean)
          .join(" ") ||
        prev.address,
      carriredCode: userInfo?.data?.user?.userId,
      carriredName:
        userInfo?.data?.user?.firstName +
        " " +
        (userInfo?.data?.user?.lastName || ""),
      userId: userInfo?.data?.user?.userId,
    }));
  };

  const loadClaimData = async (selectedCase = {}) => {
    if (selectedCase?.id) {
      const res = await dispatch(
        callgetVehicleCaseIdiomsById({ idiomsId: selectedCase.id })
      );
      if (res?.payload?.responseCode === "00000" && res?.payload?.data) {
        hydrateCaseToClaim(res.payload.data);
      }
      return;
    }

    const contractNumber = selectedCase.contractNo || selectedCase.contractNumber;
    if (!contractNumber) return;

    const res = await dispatch(
      callgetVehicleCaseIdiomsByContract({ contractNumber })
    );

    if (res?.payload?.responseCode === "00000") {
      const raw = res?.payload?.data;
      const rows = Array.isArray(raw) ? raw : raw ? [raw] : [];
      const data =
        rows.find(
          (item) => item.caseIdiomsCode === selectedCase.caseIdiomsCode
        ) || rows[0];

      if (data) hydrateCaseToClaim(data);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();

    SwalAlert.confirm(t("nameSave"), t("confirmSave"), async () => {
      try {
        setSubmitting(true);
        let error = null;
        let documentPath = "";

        if (request.documentFile?.file) {
          const upload = await dispatch(callUploadFile(request.documentFile.file));
          if (upload?.payload?.responseCode === "00000") {
            documentPath = JSON.stringify(upload?.payload?.data);
          } else {
            error = t("uploadFile.clameDocumentFile");
          }
        }

        if (error) {
          SwalAlert.error(t("claimPages.common.errorTitle"), error);
          return;
        }

        const updatedRequest = {
          ...request,
          documentPath,
        };

        const rsp = await dispatch(reqClameLifeContract(updatedRequest));
        if (rsp?.payload?.responseCode === "00000") {
          notifyListRefresh();
          if (location.state?.returnToVehicleClaimCenter) {
            navigate(-1);
          } else {
            navigate("/admin/contractControl/caseStatement");
          }
        } else {
          SwalAlert.error(
            t("claimPages.common.errorTitle"),
            `${rsp?.payload?.responseCode || ""} - ${
              rsp?.payload?.responseDescription || ""
            }`
          );
        }
      } catch (error) {
        SwalAlert.error(
          t("claimPages.common.errorTitle"),
          t("claimPages.common.serverError")
        );
      } finally {
        setSubmitting(false);
      }
    });
  };

  const handleImageSelect = (file, key) => {
    setRequest((prev) => ({
      ...prev,
      [key]: file ? { file } : null,
    }));
  };

  const handleChangeAmountType = (e) => {
    const { name, value } = e.target;
    setRequest((prev) => ({
      ...prev,
      [prev.amountType]: value,
      [name]: value,
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRequest((prev) => ({ ...prev, [name]: value }));
  };

  const amountOptions = [
    {
      value: "customerAmount",
      label: t("contracts.vehicle.clame.customerAmount"),
      icon: "fa-car-crash",
    },
    {
      value: "targetAmount",
      label: t("contracts.vehicle.clame.targetAmount"),
      icon: "fa-car-side",
    },
    {
      value: "deathAmount",
      label: t("contracts.vehicle.clame.deathAmount"),
      icon: "fa-user-injured",
    },
    {
      value: "hotpitalAmount",
      label: t("contracts.vehicle.clame.hotpitalAmount"),
      icon: "fa-hospital",
    },
    {
      value: "editerAmount",
      label: t("contracts.vehicle.clame.editerAmount"),
      icon: "fa-tools",
    },
  ];

  const selectedAmountType = amountOptions.find(
    (item) => item.value === request.amountType
  );
  const selectedBank = bankList().find(
    (item) => String(item.value) === String(request.bankType)
  );

  const claimantName =
    contractDetail?.fullName ||
    [contractDetail?.firstName, contractDetail?.lastName]
      .filter(Boolean)
      .join(" ") ||
    "-";
  const packageName =
    contractDetail?.optionNameLa ||
    contractDetail?.optionName ||
    contractDetail?.packageName ||
    "-";

  return (
    <div className="page-wrapper dashboard vehicle-claim-page">
      <span className="header-span"></span>
      <DashboardHeader />
      <MobileMenu />
      <DashboardEmployerSidebar />

      <section className="user-dashboard vehicle-claim-dashboard">
        <div className="dashboard-outer">
          <div className="vehicle-claim-topbar">
            <button
              type="button"
              className="vehicle-claim-back"
              onClick={() => navigate(-1)}
            >
              <i className="fas fa-arrow-left" />
              <span>{t("claimPages.common.back")}</span>
            </button>
          </div>

          <div className="vehicle-claim-hero">
            <div className="vehicle-claim-hero-copy">
              <div className="vehicle-claim-hero-icon">
                <i className="fas fa-car-crash" />
              </div>
              <div>
                <span className="vehicle-claim-eyebrow">
                  {__t("uiText.text422")}</span>
                <h3>{t("claimPages.vehicle.title")}</h3>
                <p>{t("claimPages.vehicle.subtitle")}</p>
              </div>
            </div>

            <div className="vehicle-claim-flow">
              <FlowStep number="1" label={t("claimPages.vehicle.steps.case")} active />
              <FlowStep number="2" label={t("claimPages.vehicle.steps.damage")} />
              <FlowStep number="3" label={t("claimPages.vehicle.steps.payment")} />
              <FlowStep number="4" label={t("claimPages.vehicle.steps.documents")} />
            </div>
          </div>

          <form onSubmit={handleSave}>
            <div className="vehicle-claim-layout">
              <main className="vehicle-claim-main">
                <section className="vehicle-claim-card">
                  <SectionTitle
                    icon="fa-file-contract"
                    title={t("claimPages.vehicle.contractTitle")}
                    subtitle={t("claimPages.vehicle.contractSubtitle")}
                  />

                  {loadingContract ? (
                    <div className="vehicle-claim-summary-loading">
                      <span />
                      <span />
                      <span />
                      <span />
                    </div>
                  ) : (
                    <div className="vehicle-claim-summary-grid">
                      <SummaryItem
                        icon="fa-hashtag"
                        label={t("claimPages.vehicle.contractNumber")}
                        value={request.contractNumber || "-"}
                        strong
                      />
                      <SummaryItem
                        icon="fa-folder-open"
                        label={t("claimPages.vehicle.caseNumber")}
                        value={request.caseIdiomsCode || "-"}
                        strong
                      />
                      <SummaryItem
                        icon="fa-car"
                        label={t("claimPages.vehicle.insuredPlate")}
                        value={request.licensePlate || "-"}
                      />
                      <SummaryItem
                        icon="fa-car-side"
                        label={t("claimPages.vehicle.thirdPartyPlate")}
                        value={request.thirdPartyLicensePlate || "-"}
                      />
                      <SummaryItem
                        icon="fa-user-shield"
                        label={t("claimPages.vehicle.insured")}
                        value={claimantName}
                      />
                      <SummaryItem
                        icon="fa-box-open"
                        label={t("claimPages.vehicle.package")}
                        value={packageName}
                      />
                      <SummaryItem
                        icon="fa-calendar-alt"
                        label={t("claimPages.vehicle.incidentDate")}
                        value={formatDateTime(request.deadDate)}
                      />
                      <SummaryItem
                        icon="fa-map-marker-alt"
                        label={t("claimPages.vehicle.incidentLocation")}
                        value={request.addressItem || "-"}
                      />
                    </div>
                  )}
                </section>

                <section className="vehicle-claim-card">
                  <SectionTitle
                    icon="fa-file-invoice-dollar"
                    title={t("claimPages.vehicle.detailTitle")}
                    subtitle={t("claimPages.vehicle.detailSubtitle")}
                    badge={t("claimPages.common.step", { number: 2 })}
                  />

                  <div className="vehicle-claim-field vehicle-claim-field-full">
                    <label>
                      {t("contracts.vehicle.clame.amountType")}
                      <Required />
                    </label>
                    <div className="vehicle-claim-amount-types">
                      {amountOptions.map((item) => {
                        const selected = request.amountType === item.value;
                        return (
                          <label
                            key={item.value}
                            className={`vehicle-claim-amount-card ${
                              selected ? "selected" : ""
                            }`}
                          >
                            <input
                              type="radio"
                              name="amountType"
                              value={item.value}
                              checked={selected}
                              onChange={handleChange}
                            />
                            <span className="vehicle-claim-amount-icon">
                              <i className={`fas ${item.icon}`} />
                            </span>
                            <span>{item.label}</span>
                            <i className="fas fa-check vehicle-claim-selected-check" />
                          </label>
                        );
                      })}
                    </div>
                  </div>

                  <div className="vehicle-claim-form-grid vehicle-claim-form-grid-spaced">
                    <div className="vehicle-claim-field">
                      <label>
                        {t("contracts.vehicle.clame.claimAmount")}
                        <Required />
                      </label>
                      <div className="vehicle-claim-control-wrap">
                        <i className="fas fa-coins" />
                        <InputNumberFormat
                          type="text"
                          name="claimAmount"
                          className="vehicle-claim-control with-icon amount"
                          placeholder={t("contracts.vehicle.clame.claimAmount")}
                          value={request.claimAmount}
                          onChange={handleChangeAmountType}
                          autoComplete="off"
                          required
                        />
                        <span className="vehicle-claim-currency">LAK</span>
                      </div>
                    </div>

                    <div className="vehicle-claim-field vehicle-claim-readonly-field">
                      <label>{t("claimPages.vehicle.incidentLocation")}</label>
                      <div className="vehicle-claim-control-wrap">
                        <i className="fas fa-map-marker-alt" />
                        <input
                          type="text"
                          className="vehicle-claim-control with-icon"
                          value={request.address || "-"}
                          disabled
                          readOnly
                        />
                      </div>
                    </div>

                    <div className="vehicle-claim-field vehicle-claim-field-full">
                      <label>{t("contracts.life.clame.description")}</label>
                      <textarea
                        className="vehicle-claim-textarea"
                        name="description"
                        rows="4"
                        value={request.description || ""}
                        onChange={handleChange}
                        placeholder={t("claimPages.vehicle.detailPlaceholder")}
                      />
                    </div>

                    <div className="vehicle-claim-field vehicle-claim-field-full">
                      <label>{t("contracts.vehicle.clame.note")}</label>
                      <textarea
                        className="vehicle-claim-textarea compact"
                        name="note"
                        rows="3"
                        value={request.note || ""}
                        onChange={handleChange}
                        placeholder={t("claimPages.vehicle.internalNotePlaceholder")}
                      />
                    </div>
                  </div>
                </section>

                <section className="vehicle-claim-card">
                  <SectionTitle
                    icon="fa-university"
                    title={t("claimPages.vehicle.paymentTitle")}
                    subtitle={t("claimPages.vehicle.paymentSubtitle")}
                    badge={t("claimPages.common.step", { number: 3 })}
                  />

                  <div className="vehicle-claim-form-grid">
                    <div className="vehicle-claim-field">
                      <label>{t("contracts.life.clame.bankType")}</label>
                      <div className="vehicle-claim-select-wrap">
                        <span className="vehicle-claim-select-icon">
                          <i className="fas fa-university" />
                        </span>
                        <select
                          className="vehicle-claim-select"
                          name="bankType"
                          onChange={handleChange}
                          value={request.bankType || ""}
                        >
                          <option value="">{t("pleaseSelect")}</option>
                          {bankList().map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>
                        <span className="vehicle-claim-select-arrow" aria-hidden="true">
                          <i className="fas fa-chevron-down" />
                        </span>
                      </div>
                    </div>

                    <div className="vehicle-claim-field">
                      <label>{t("contracts.life.clame.bankAccName")}</label>
                      <div className="vehicle-claim-control-wrap">
                        <i className="fas fa-id-card" />
                        <input
                          type="text"
                          name="bankAccName"
                          className="vehicle-claim-control with-icon"
                          placeholder={t("contracts.life.clame.bankAccName")}
                          onChange={handleChange}
                          value={request.bankAccName || ""}
                          autoComplete="off"
                        />
                      </div>
                    </div>

                    <div className="vehicle-claim-field">
                      <label>{t("contracts.life.clame.bankAcc")}</label>
                      <div className="vehicle-claim-control-wrap">
                        <i className="fas fa-credit-card" />
                        <input
                          type="text"
                          name="bankAcc"
                          className="vehicle-claim-control with-icon"
                          placeholder={t("contracts.life.clame.bankAcc")}
                          onChange={handleChange}
                          value={request.bankAcc || ""}
                          autoComplete="off"
                        />
                      </div>
                    </div>

                    <div className="vehicle-claim-field">
                      <label>{t("contracts.life.clame.bankMethod")}</label>
                      <div className="vehicle-claim-control-wrap">
                        <i className="fas fa-money-check-alt" />
                        <input
                          type="text"
                          name="bankMethod"
                          className="vehicle-claim-control with-icon"
                          placeholder={t("contracts.life.clame.bankMethod")}
                          onChange={handleChange}
                          value={request.bankMethod || ""}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  </div>
                </section>

                <section className="vehicle-claim-card">
                  <SectionTitle
                    icon="fa-paperclip"
                    title={t("claimPages.vehicle.documentsTitle")}
                    subtitle={t("claimPages.vehicle.documentsSubtitle")}
                    badge={t("claimPages.common.step", { number: 4 })}
                  />

                  <div className="vehicle-claim-upload-block">
                    <div className="vehicle-claim-upload-heading">
                      <div>
                        <strong>
                          {t("contracts.vehicle.clame.document")}
                          <Required />
                        </strong>
                        <p>
                          {t("claimPages.vehicle.documentsHelp")}
                        </p>
                      </div>
                      <span className="vehicle-claim-file-hint">JPG, PNG, PDF</span>
                    </div>
                    <FileUploadGrid
                      multiple={true}
                      folderName="clameDocumentFile"
                      onChange={(file) =>
                        handleImageSelect(file, "documentFile")
                      }
                      accept="image/*,application/pdf"
                      required
                      requiredMessage={t("claimPages.vehicle.documentsRequired")}
                    />
                  </div>
                </section>

                <div className="vehicle-claim-mobile-submit">
                  <button
                    className="vehicle-claim-submit"
                    type="submit"
                    disabled={submitting}
                  >
                    {submitting ? (
                      <>
                        <i className="fas fa-spinner fa-spin" />
                        {t("claimPages.common.submitting")}
                      </>
                    ) : (
                      <>
                        <i className="fas fa-paper-plane" />
                        {t("claimPages.common.submitRequest")}
                      </>
                    )}
                  </button>
                </div>
              </main>

              <aside className="vehicle-claim-side">
                <div className="vehicle-claim-side-card sticky">
                  <div className="vehicle-claim-side-title">
                    <span className="vehicle-claim-side-icon">
                      <i className="fas fa-clipboard-check" />
                    </span>
                    <div>
                      <h5>{t("claimPages.vehicle.summaryTitle")}</h5>
                      <p>{t("claimPages.vehicle.summarySubtitle")}</p>
                    </div>
                  </div>

                  <div className="vehicle-claim-review-list">
                    <ReviewRow label={t("claimPages.vehicle.contractNumber")} value={request.contractNumber || "-"} />
                    <ReviewRow label={t("claimPages.vehicle.caseNumber")} value={request.caseIdiomsCode || "-"} />
                    <ReviewRow label={t("claimPages.vehicle.licensePlate")} value={request.licensePlate || "-"} />
                    <ReviewRow
                      label={t("claimPages.vehicle.damageType")}
                      value={selectedAmountType?.label || t("claimPages.common.notSelected")}
                      empty={!selectedAmountType}
                    />
                    <ReviewRow
                      label={t("claimPages.vehicle.claimAmount")}
                      value={`${formatAmount(request.claimAmount)} LAK`}
                      highlight
                    />
                    <ReviewRow
                      label={t("claimPages.vehicle.bank")}
                      value={selectedBank?.label || t("claimPages.common.notSelected")}
                      empty={!selectedBank}
                    />
                    <ReviewRow
                      label={t("claimPages.vehicle.accountName")}
                      value={request.bankAccName || t("claimPages.common.notSpecified")}
                      empty={!request.bankAccName}
                    />
                    <ReviewRow
                      label={t("claimPages.vehicle.accountNumber")}
                      value={request.bankAcc || t("claimPages.common.notSpecified")}
                      empty={!request.bankAcc}
                    />
                  </div>

                  <div className="vehicle-claim-security-note">
                    <i className="fas fa-shield-alt" />
                    <p>{t("claimPages.vehicle.securityNote")}</p>
                  </div>

                  <button
                    className="vehicle-claim-submit desktop"
                    type="submit"
                    disabled={submitting}
                  >
                    {submitting ? (
                      <>
                        <i className="fas fa-spinner fa-spin" />
                        {t("claimPages.common.submitting")}
                      </>
                    ) : (
                      <>
                        <i className="fas fa-paper-plane" />
                        {t("claimPages.common.submitRequest")}
                      </>
                    )}
                  </button>

                  <button
                    type="button"
                    className="vehicle-claim-cancel"
                    onClick={() => navigate(-1)}
                    disabled={submitting}
                  >
                    {t("claimPages.common.cancel")}
                  </button>
                </div>
              </aside>
            </div>
          </form>
        </div>
      </section>

      <CopyrightFooter />
    </div>
  );
};

const Required = () => <span className="vehicle-claim-required">*</span>;

const FlowStep = ({ number, label, active = false }) => (
  <div className={`vehicle-claim-flow-step ${active ? "active" : ""}`}>
    <span>{number}</span>
    <small>{label}</small>
  </div>
);

const SectionTitle = ({ icon, title, subtitle, badge }) => (
  <div className="vehicle-claim-section-title">
    <div className="vehicle-claim-section-icon">
      <i className={`fas ${icon}`} />
    </div>
    <div className="vehicle-claim-section-copy">
      <div className="vehicle-claim-section-heading">
        <h5>{title}</h5>
        {badge && <span>{badge}</span>}
      </div>
      <p>{subtitle}</p>
    </div>
  </div>
);

const SummaryItem = ({ icon, label, value, strong = false }) => (
  <div className="vehicle-claim-summary-item">
    <span className="vehicle-claim-summary-icon">
      <i className={`fas ${icon}`} />
    </span>
    <div>
      <small>{label}</small>
      <strong className={strong ? "primary" : ""}>{value}</strong>
    </div>
  </div>
);

const ReviewRow = ({ label, value, empty = false, highlight = false }) => (
  <div className="vehicle-claim-review-row">
    <span>{label}</span>
    <strong
      className={`${empty ? "empty" : ""} ${highlight ? "highlight" : ""}`}
    >
      {value}
    </strong>
  </div>
);

const formatDateTime = (value) => {
  if (!value) return "-";
  const date = moment(value);
  return date.isValid() ? date.format("DD/MM/YYYY HH:mm") : "-";
};

const formatAmount = (value) => {
  const amount = Number(String(value ?? 0).replace(/,/g, ""));
  if (!Number.isFinite(amount)) return "0";
  return new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(
    amount
  );
};

export default VehicleClaim;
